
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bieIR", function(module, exports) {

var $6Htct = parcelRequire("6Htct");

function $064d70b35e108d7a$export$f50ba6ebca86afae(action) {
    return action.handleType === (0, $6Htct.HandleActionType).Chat;
}
function $064d70b35e108d7a$export$e0faf22bf5023c5e(action) {
    return action.handleType === (0, $6Htct.HandleActionType).Nested;
}
function $064d70b35e108d7a$export$ce07703e397785f3(action) {
    return action.handleType === (0, $6Htct.HandleActionType).Skill;
}
function $064d70b35e108d7a$export$38d6fa0daaae0008(action) {
    return action.handleType === (0, $6Htct.HandleActionType).Skill && 'dynamicPrompt' in action && (0, $6Htct.LEGACY_DYNAMIC_SKILL_IDS).has(action.id);
}
function $064d70b35e108d7a$export$426fd22b878fe58d(action) {
    return $064d70b35e108d7a$export$f50ba6ebca86afae(action) || $064d70b35e108d7a$export$e0faf22bf5023c5e(action) || $064d70b35e108d7a$export$ce07703e397785f3(action);
}
module.exports["isChatAction"] = $064d70b35e108d7a$export$f50ba6ebca86afae;
module.exports["isNestedAction"] = $064d70b35e108d7a$export$e0faf22bf5023c5e;
module.exports["isSkillAction"] = $064d70b35e108d7a$export$ce07703e397785f3;

});

parcelRegister("ahwTE", function(module, exports) {

var $6Htct = parcelRequire("6Htct");

const $e77c5549fdbcdd9e$var$supportedPageContextTypes = [
    (0, $6Htct.PageContextType).CONFLUENCE_PAGE_VIEW,
    (0, $6Htct.PageContextType).CONFLUENCE_PAGE_EDIT
];
const $e77c5549fdbcdd9e$export$c2a686cb0530eec8 = (pageContextType)=>{
    return $e77c5549fdbcdd9e$var$supportedPageContextTypes.includes(pageContextType);
};
module.exports["isPageContextTypeSupportedForDynamicStarters"] = $e77c5549fdbcdd9e$export$c2a686cb0530eec8;

});

parcelRegister("71TxW", function(module, exports) {

var $6Htct = parcelRequire("6Htct");

const $89c56891f025255d$export$10c6f1bef31d587c = [
    'database',
    'embed',
    'folder'
];
const $89c56891f025255d$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($89c56891f025255d$export$10c6f1bef31d587c.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
const $89c56891f025255d$export$ee833111bcbf78d7 = (url, pageContextType)=>{
    if (pageContextType === (0, $6Htct.PageContextType).CONFLUENCE_PAGE_EDIT || pageContextType === (0, $6Htct.PageContextType).CONFLUENCE_BLOG_EDIT) {
        // Match: /pages/edit-v2/{resourceId} or /blog/edit-v2/{resourceId}
        const match = url.match(/\/(?:pages|blog)\/edit-v2\/(\d+)/);
        return match ? match[1] : null;
    }
    if (pageContextType === (0, $6Htct.PageContextType).CONFLUENCE_PAGE_VIEW) {
        // Page pattern: /pages/{resourceId}/
        const match = url.match(/\/pages\/(\d+)(?:\/|$|[?#])/);
        return match ? match[1] : null;
    }
    if (pageContextType === (0, $6Htct.PageContextType).CONFLUENCE_BLOG_VIEW) {
        // Blog pattern: /blog/{year}/{month}/{day}/{resourceId}/
        const match = url.match(/\/blog\/\d{4}\/\d{2}\/\d{2}\/(\d+)/);
        return match ? match[1] : null;
    }
    return null;
};
const $89c56891f025255d$export$3bb5b6748490a3c9 = (siteId, contentUrl, pageContextType)=>{
    const resourceId = $89c56891f025255d$export$ee833111bcbf78d7(contentUrl, pageContextType);
    if (!resourceId) return null;
    const isBlogPost = /\/spaces\/[^\/]+\/blog\//.test(contentUrl);
    const resourceType = isBlogPost ? 'blogpost' : 'page';
    return $89c56891f025255d$export$6a2f2c83863e9bfe({
        siteId: siteId,
        resourceType: resourceType,
        activationId: '',
        resourceId: // Not needed for pages/blogposts
        resourceId
    });
};
module.exports["getContentAri"] = $89c56891f025255d$export$3bb5b6748490a3c9;

});

parcelRegister("codiQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");

const $ec1a377473a68b80$export$46133998910543ac = (0, $42omo.createContext)(null);
const $ec1a377473a68b80$export$6fa751d66e55d2e1 = (usePathname)=>{
    const [location, setLocation] = (0, $42omo.useState)(usePathname ? window.location.pathname : window.location.href);
    // For easier mocking
    const contextValue = (0, $42omo.useContext)($ec1a377473a68b80$export$46133998910543ac);
    const handleLocationChange = (0, $42omo.useCallback)(()=>{
        const newValue = usePathname ? window.location.pathname : window.location.href;
        if (newValue !== location) setLocation(newValue);
    }, [
        location,
        setLocation,
        usePathname
    ]);
    (0, $42omo.useEffect)(()=>{
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;
        window.history.pushState = function(...args) {
            originalPushState.apply(this, args);
            handleLocationChange();
        };
        window.history.replaceState = function(...args_0) {
            originalReplaceState.apply(this, args_0);
            handleLocationChange();
        };
        const unbind = (0, $fFa3V.bindAll)(window, [
            {
                type: 'popstate',
                listener: handleLocationChange
            }
        ]);
        return ()=>{
            unbind();
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, [
        handleLocationChange
    ]);
    return contextValue ?? location;
};
module.exports["useWindowLocation"] = $ec1a377473a68b80$export$6fa751d66e55d2e1;

});

parcelRegister("e96kn", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6TWiP = parcelRequire("6TWiP");


var $lDwiy = parcelRequire("lDwiy");


var $a6IPc = parcelRequire("a6IPc");


var $cyLm6 = parcelRequire("cyLm6");


var $fNJG8 = parcelRequire("fNJG8");


var $2MNkP = parcelRequire("2MNkP");


var $l8mxb = parcelRequire("l8mxb");


var $jluld = parcelRequire("jluld");


var $fIcbd = parcelRequire("fIcbd");


var $dh538 = parcelRequire("dh538");


var $6Htct = parcelRequire("6Htct");


var $codiQ = parcelRequire("codiQ");


var $30mnF = parcelRequire("30mnF");


var $kj1we = parcelRequire("kj1we");

const $fdaa4277f20d9667$export$c6a4ebf596b0c08a = {
    [(0, $6Htct.PageContextType).BITBUCKET_CREATE_PULL_REQUEST]: [
        {
            labelType: 'find-people',
            message: (0, $kj1we.default).bitbucketCreatePullRequestsPrompt1
        }
    ],
    [(0, $6Htct.PageContextType).BITBUCKET_PULL_REQUEST]: [
        {
            labelType: 'summarize-information',
            message: (0, $kj1we.default).bitbucketPullRequestsPrompt1
        },
        {
            labelType: 'summarize-code',
            message: (0, $kj1we.default).bitbucketPullRequestsPrompt4
        },
        {
            labelType: 'analyze-content',
            message: (0, $kj1we.default).bitbucketPullRequestsPrompt3
        },
        {
            labelType: 'get-answers',
            message: (0, $kj1we.default).bitbucketPullRequestsPrompt5
        },
        {
            labelType: 'find-people',
            message: (0, $kj1we.default).bitbucketPullRequestsPrompt6
        }
    ],
    [(0, $6Htct.PageContextType).BITBUCKET_REPOSITORY_SOURCE]: [
        {
            labelType: 'summarize-code',
            message: (0, $kj1we.default).bitbucketRepositorySourcePrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).bitbucketRepositorySourcePrompt4
        },
        {
            labelType: 'code-search',
            message: (0, $kj1we.default).bitbucketRepositorySourcePrompt5
        }
    ],
    [(0, $6Htct.PageContextType).BITBUCKET_PIPELINES]: [
        {
            labelType: 'get-answers',
            message: (0, $kj1we.default).bitbucketPipelinePrompt1
        }
    ],
    [(0, $6Htct.PageContextType).BITBUCKET]: [
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).bitbucketPrompt5
        },
        {
            labelType: 'check-status',
            message: (0, $kj1we.default).bitbucketPrompt6
        },
        {
            labelType: 'find-people',
            message: (0, $kj1we.default).bitbucketPrompt7
        }
    ],
    [(0, $6Htct.PageContextType).CONFLUENCE_HOME]: [
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).confluenceHomePrompt1
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $kj1we.default).confluenceHomePrompt2
        },
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).confluenceHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).confluenceHomePrompt4
        },
        {
            labelType: 'rephrase-content',
            message: (0, $kj1we.default).confluenceHomePrompt5
        },
        {
            labelType: 'draft-content',
            message: (0, $kj1we.default).confluenceHomePrompt6
        },
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).confluenceHomePrompt7
        },
        {
            labelType: 'find-people',
            message: (0, $kj1we.default).confluenceHomePrompt8
        },
        {
            labelType: 'find-people',
            message: (0, $kj1we.default).confluenceHomePrompt9
        },
        {
            labelType: 'find-people',
            message: (0, $kj1we.default).confluenceHomePrompt10
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).confluenceHomePrompt11
        }
    ],
    [(0, $6Htct.PageContextType).CONFLUENCE_PAGE_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).confluencePageViewPrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).confluencePageViewPrompt2
        },
        {
            labelType: 'rephrase-content',
            message: (0, $kj1we.default).confluencePageViewPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $kj1we.default).confluencePageViewPrompt4
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $kj1we.default).confluencePageViewPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).confluencePageViewPrompt6
        }
    ],
    [(0, $6Htct.PageContextType).CONFLUENCE_BLOG_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).confluencePageViewPrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).confluencePageViewPrompt2
        },
        {
            labelType: 'rephrase-content',
            message: (0, $kj1we.default).confluencePageViewPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $kj1we.default).confluencePageViewPrompt4
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $kj1we.default).confluencePageViewPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).confluencePageViewPrompt6
        }
    ],
    [(0, $6Htct.PageContextType).CONFLUENCE_WHITEBOARD]: [
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).confluenceWhiteboardPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $kj1we.default).confluenceWhiteboardPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).confluenceWhiteboardPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).confluenceWhiteboardPrompt4
        }
    ],
    [(0, $6Htct.PageContextType).CONFLUENCE_PAGE_EDIT]: [
        {
            labelType: 'rephrase-content',
            message: (0, $kj1we.default).confluencePageEditPrompt1
        },
        {
            labelType: 'draft-content',
            message: (0, $kj1we.default).confluencePageEditPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).confluencePageEditPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).confluencePageEditPrompt4
        }
    ],
    [(0, $6Htct.PageContextType).CONFLUENCE_BLOG_EDIT]: [
        {
            labelType: 'rephrase-content',
            message: (0, $kj1we.default).confluencePageEditPrompt1
        },
        {
            labelType: 'draft-content',
            message: (0, $kj1we.default).confluencePageEditPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).confluencePageEditPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).confluencePageEditPrompt4
        }
    ],
    [(0, $6Htct.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY]: [],
    [(0, $6Htct.PageContextType).JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY]: [],
    [(0, $6Htct.PageContextType).JIRA_TMP_SPACE_SETTINGS_ACCESS]: [],
    [(0, $6Htct.PageContextType).JIRA_HOME]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $kj1we.default).jiraHomePrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).jiraHomePrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).jiraHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).jiraHomePrompt4
        },
        {
            labelType: 'draft-content',
            message: (0, $kj1we.default).jiraHomePrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).jiraHomePrompt6
        }
    ],
    [(0, $6Htct.PageContextType).JIRA_FOR_YOU]: [
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).unknownPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).unknownPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $kj1we.default).unknownPrompt3
        }
    ],
    [(0, $6Htct.PageContextType).JIRA_ISSUE_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).jiraIssueViewPrompt1
        },
        {
            labelType: 'rephrase-content',
            message: (0, $kj1we.default).jiraIssueViewPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $kj1we.default).jiraIssueViewPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).jiraIssueViewPrompt4
        }
    ],
    [(0, $6Htct.PageContextType).JIRA_PROJECT]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $kj1we.default).jiraProjectPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).jiraProjectPrompt2
        },
        {
            labelType: 'measure-productivity',
            message: (0, $kj1we.default).jiraProjectPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $kj1we.default).jiraProjectPrompt4
        },
        {
            labelType: 'find-people',
            message: (0, $kj1we.default).jiraProjectPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).jiraProjectPrompt6
        },
        {
            labelType: 'measure-productivity',
            message: (0, $kj1we.default).jiraProjectPrompt7
        },
        {
            labelType: 'find-people',
            message: (0, $kj1we.default).jiraProjectPrompt8
        },
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).jiraProjectPrompt9
        },
        {
            labelType: 'get-answers',
            message: (0, $kj1we.default).jiraProjectPrompt10
        },
        {
            labelType: 'rephrase-content',
            message: (0, $kj1we.default).jiraProjectPrompt11
        },
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).jiraProjectPrompt12
        },
        {
            labelType: 'draft-content',
            message: (0, $kj1we.default).jiraProjectPrompt13
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).jiraProjectPrompt14
        }
    ],
    [(0, $6Htct.PageContextType).JSM_INCIDENT_VIEW]: [
        {
            labelType: 'find-people',
            message: (0, $kj1we.default).jsmIncidentViewPrompt1
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $kj1we.default).jsmIncidentViewPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $kj1we.default).jsmIncidentViewPrompt3
        }
    ],
    [(0, $6Htct.PageContextType).JSM_INCIDENT_LIST_VIEW]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $kj1we.default).jsmIncidentListViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $kj1we.default).jsmIncidentListViewPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).jsmIncidentListViewPrompt3
        }
    ],
    [(0, $6Htct.PageContextType).JSM_ALERT_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).jsmAlertViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $kj1we.default).jsmAlertViewPrompt2
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $kj1we.default).jsmAlertViewPrompt3
        }
    ],
    [(0, $6Htct.PageContextType).JSM_ALERT_LIST_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).jsmAlertListViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $kj1we.default).jsmAlertListViewPrompt2
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $kj1we.default).jsmAlertListViewPrompt3
        }
    ],
    [(0, $6Htct.PageContextType).JSM_ALERT_GROUP_DETAIL_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).jsmAlertGroupDetailViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $kj1we.default).jsmAlertGroupDetailViewPrompt2
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $kj1we.default).jsmAlertGroupDetailViewPrompt3
        }
    ],
    [(0, $6Htct.PageContextType).ATLAS_HOME]: [
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).atlasHomePrompt1
        },
        {
            labelType: 'measure-productivity',
            message: (0, $kj1we.default).atlasHomePrompt2
        },
        {
            labelType: 'get-answers',
            message: (0, $kj1we.default).atlasHomePrompt3
        },
        {
            labelType: 'draft-content',
            message: (0, $kj1we.default).atlasHomePrompt4
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).atlasHomePrompt5
        },
        {
            labelType: 'draft-content',
            message: (0, $kj1we.default).atlasHomePrompt6
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).confluenceHomePrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).confluenceHomePrompt4
        },
        {
            labelType: 'rephrase-content',
            message: (0, $kj1we.default).confluenceHomePrompt5
        },
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).confluenceHomePrompt11
        },
        {
            labelType: 'find-people',
            message: (0, $kj1we.default).confluenceHomePrompt8
        },
        {
            labelType: 'find-people',
            message: (0, $kj1we.default).confluenceHomePrompt10
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $kj1we.default).jiraHomePrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).jiraHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).jiraHomePrompt4
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).atlasHomePrompt7
        }
    ],
    [(0, $6Htct.PageContextType).ATLAS_HOME_MAIN]: [],
    [(0, $6Htct.PageContextType).ATLAS_HOME_DISCOVER]: [],
    [(0, $6Htct.PageContextType).ATLAS_HOME_RECENTS]: [],
    [(0, $6Htct.PageContextType).ATLAS_HOME_FULL_PAGE_NOTIFICATIONS]: [],
    [(0, $6Htct.PageContextType).ATLAS_HOME_PROJECT_UPDATES_LIST]: [],
    [(0, $6Htct.PageContextType).ATLAS_HOME_GOAL_UPDATES_LIST]: [],
    [(0, $6Htct.PageContextType).ATLAS_HOME_TEAM_UPDATES_LIST]: [],
    [(0, $6Htct.PageContextType).ATLAS_HOME_TAG_UPDATES_LIST]: [],
    [(0, $6Htct.PageContextType).FOCUS]: [
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).focusPrompt1
        },
        {
            labelType: 'measure-productivity',
            message: (0, $kj1we.default).focusPrompt2
        }
    ],
    [(0, $6Htct.PageContextType).FOCUS_FOR_YOU]: [
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).focusForYouPrompt1
        }
    ],
    [(0, $6Htct.PageContextType).FOCUS_FOCUS_AREA_PAGE]: [
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).focusAreaPrompt1
        }
    ],
    [(0, $6Htct.PageContextType).FOCUS_FOCUS_AREA_GOAL_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).focusAreaGoalPrompt1
        }
    ],
    [(0, $6Htct.PageContextType).FOCUS_FOCUS_AREA_WORK_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).focusAreaWorkPrompt1
        }
    ],
    [(0, $6Htct.PageContextType).SAC]: [
        {
            labelType: 'manage-settings',
            message: (0, $kj1we.default).sacPrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).sacPrompt2
        },
        {
            labelType: 'automation-rule',
            message: (0, $kj1we.default).sacPrompt3
        }
    ],
    [(0, $6Htct.PageContextType).TRELLO_BOARD]: [
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).trelloBoardPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).trelloBoardPrompt2
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).trelloBoardPrompt3
        }
    ],
    [(0, $6Htct.PageContextType).TRELLO_CARD]: [
        {
            labelType: 'summarize-content',
            message: (0, $kj1we.default).trelloCardPrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).trelloCardPrompt2
        },
        {
            labelType: 'rephrase-content',
            message: (0, $kj1we.default).trelloCardPrompt3
        }
    ],
    [(0, $6Htct.PageContextType).UNKNOWN]: [
        {
            labelType: 'find-information',
            message: (0, $kj1we.default).unknownPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $kj1we.default).unknownPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $kj1we.default).unknownPrompt3
        }
    ],
    [(0, $6Htct.PageContextType).ADMIN_HUB]: []
};
const $fdaa4277f20d9667$export$a905239756c1fbae = (location)=>{
    const jsmIncidentViewPatterns = [
        // Single incident view (with issue key at the end)
        [
            (0, $6Htct.PageContextType).JSM_INCIDENT_VIEW,
            /\/jira\/servicedesk\/projects\/[^\/]+\/section\/incidents\/custom\/\d+\/[A-Z]+-\d+/
        ]
    ];
    const jsmOpsPatterns = (0, $dh538.fg)('rovo_ops_conversation_starters_enabled') ? [
        // Incident list view (without issue key at the end)
        [
            (0, $6Htct.PageContextType).JSM_INCIDENT_LIST_VIEW,
            /\/jira\/servicedesk\/projects\/[^\/]+\/section\/incidents\/custom\/\d+$/
        ],
        // Single alert view (has / after alerts)
        [
            (0, $6Htct.PageContextType).JSM_ALERT_VIEW,
            /\/jira\/ops\/alerts\//
        ],
        // Alert list view (has ? after alerts)
        [
            (0, $6Htct.PageContextType).JSM_ALERT_LIST_VIEW,
            /\/jira\/ops\/alerts\?/
        ],
        // Alert group detail view
        [
            (0, $6Htct.PageContextType).JSM_ALERT_GROUP_DETAIL_VIEW,
            /\/jira\/ops\/group-detail\//
        ]
    ] : [];
    const urlPatterns = [
        [
            (0, $6Htct.PageContextType).BITBUCKET_REPOSITORY_SOURCE,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/src\//
        ],
        [
            (0, $6Htct.PageContextType).BITBUCKET_PULL_REQUEST,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/pull-requests\/\d+/
        ],
        [
            (0, $6Htct.PageContextType).BITBUCKET_CREATE_PULL_REQUEST,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/pull-requests\/new/
        ],
        [
            (0, $6Htct.PageContextType).BITBUCKET_PIPELINES,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/pipelines\/results\/[^\/]+\/steps\//
        ],
        [
            (0, $6Htct.PageContextType).BITBUCKET,
            /bitbucket\.org\/.*/
        ],
        [
            (0, $6Htct.PageContextType).CONFLUENCE_HOME,
            /\/wiki\/?$/
        ],
        [
            (0, $6Htct.PageContextType).CONFLUENCE_HOME,
            /\/wiki\/home$/
        ],
        [
            (0, $6Htct.PageContextType).CONFLUENCE_BLOG_EDIT,
            /\/wiki\/spaces\/[^\/]+\/blog\/edit-v2\//
        ],
        [
            (0, $6Htct.PageContextType).CONFLUENCE_BLOG_VIEW,
            /\/wiki\/spaces\/[^\/]+\/blog\//
        ],
        [
            (0, $6Htct.PageContextType).CONFLUENCE_PAGE_EDIT,
            /\/wiki\/spaces\/[^\/]+\/pages\/edit-v2\//
        ],
        [
            (0, $6Htct.PageContextType).CONFLUENCE_PAGE_VIEW,
            /\/wiki\/spaces\/[^\/]+\/pages\//
        ],
        [
            (0, $6Htct.PageContextType).CONFLUENCE_WHITEBOARD,
            /\/wiki\/spaces\/[^\/]+\/whiteboard\//
        ],
        [
            (0, $6Htct.PageContextType).JIRA_ISSUE_VIEW,
            /\/browse\/[^\/]+$/
        ],
        [
            (0, $6Htct.PageContextType).JIRA_ISSUE_VIEW,
            /\/jira\/.+\/projects\/[^/]+\/[^?]+\?(?:.*&)?selectedIssue=/
        ],
        ...jsmIncidentViewPatterns,
        ...jsmOpsPatterns,
        [
            (0, $6Htct.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY,
            /\/plugins\/servlet\/project-config\/[^\/]+\/people/
        ],
        [
            (0, $6Htct.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY,
            /\/plugins\/servlet\/project-config\/[^\/]+\/permissions/
        ],
        [
            (0, $6Htct.PageContextType).JIRA_TMP_SPACE_SETTINGS_ACCESS,
            /\/jira\/software\/projects\/[^\/]+\/settings\/access/
        ],
        [
            (0, $6Htct.PageContextType).JIRA_PROJECT,
            /\/jira\/.+\/projects\//
        ],
        [
            (0, $6Htct.PageContextType).JIRA_HOME,
            /\/jira\/dashboards\/last-visited$/
        ],
        [
            (0, $6Htct.PageContextType).JIRA_FOR_YOU,
            /\/jira\/for-you$/
        ],
        // atlas home is either home.atlassian.com, home.stg.atlassian.com, team.atlassian.com, or team.stg.atlassian.com
        [
            (0, $6Htct.PageContextType).ATLAS_HOME_DISCOVER,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*discover+/
        ],
        [
            (0, $6Htct.PageContextType).ATLAS_HOME_RECENTS,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*recents+/
        ],
        [
            (0, $6Htct.PageContextType).ATLAS_HOME_FULL_PAGE_NOTIFICATIONS,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*notifications+/
        ],
        [
            (0, $6Htct.PageContextType).ATLAS_HOME_PROJECT_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/projects+/
        ],
        [
            (0, $6Htct.PageContextType).ATLAS_HOME_GOAL_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/goals+/
        ],
        [
            (0, $6Htct.PageContextType).ATLAS_HOME_TEAM_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/team+/
        ],
        [
            (0, $6Htct.PageContextType).ATLAS_HOME_TAG_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/tag+/
        ],
        [
            (0, $6Htct.PageContextType).ATLAS_HOME_MAIN,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*\?cloudId=[^\/]+/
        ],
        [
            (0, $6Htct.PageContextType).ATLAS_HOME,
            /\/(home|team)\./
        ],
        [
            (0, $6Htct.PageContextType).FOCUS_FOCUS_AREA_GOAL_VIEW,
            /\/focus\/focus-area\/.*\/goals/
        ],
        [
            (0, $6Htct.PageContextType).FOCUS_FOCUS_AREA_WORK_VIEW,
            /\/focus\/focus-area\/.*\/work/
        ],
        [
            (0, $6Htct.PageContextType).FOCUS_FOCUS_AREA_PAGE,
            /\/focus\/focus-area\/.*/
        ],
        [
            (0, $6Htct.PageContextType).FOCUS_FOR_YOU,
            /\/focus\/for-you(?:\/.*)?$/
        ],
        [
            (0, $6Htct.PageContextType).FOCUS,
            /\/focus\/.*/
        ],
        [
            (0, $6Htct.PageContextType).SAC,
            /support\.atlassian\.com/
        ],
        // Trello: card view first (more specific), then board. Prod: trello.com, Staging: trellis.coffee (and *.atlassian.com)
        [
            (0, $6Htct.PageContextType).TRELLO_CARD,
            /(?:trello\.com|trellis\.coffee|[\w-]*trello[\w-]*\.(?:stg\.)?atlassian\.com)\/c\//
        ],
        [
            (0, $6Htct.PageContextType).TRELLO_BOARD,
            /(?:trello\.com|trellis\.coffee|[\w-]*trello[\w-]*\.(?:stg\.)?atlassian\.com)\/b\//
        ],
        // admin hub: admin.atlassian.com (production) or admin.stg.atlassian.com (staging)
        [
            (0, $6Htct.PageContextType).ADMIN_HUB,
            /admin(\.stg)?\.atlassian\.com/
        ]
    ];
    for (const [type, pattern] of urlPatterns){
        const matched = pattern.test(location);
        if (!matched) continue;
        return type;
    }
    return (0, $6Htct.PageContextType).UNKNOWN;
};
const $fdaa4277f20d9667$export$bc4bf2ff8e40b690 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(5);
    const location = (0, $codiQ.useWindowLocation)();
    let t0;
    if ($[0] !== location) {
        t0 = $fdaa4277f20d9667$export$a905239756c1fbae(location);
        $[0] = location;
        $[1] = t0;
    } else t0 = $[1];
    const [pageContextType, setPageContextType] = (0, $42omo.useState)(t0);
    let t1;
    let t2;
    if ($[2] !== location) {
        t1 = ()=>{
            setPageContextType($fdaa4277f20d9667$export$a905239756c1fbae(location));
        };
        t2 = [
            location
        ];
        $[2] = location;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    return pageContextType;
} : ()=>{
    const location = (0, $codiQ.useWindowLocation)();
    const [pageContextType, setPageContextType] = (0, $42omo.useState)($fdaa4277f20d9667$export$a905239756c1fbae(location));
    (0, $42omo.useEffect)(()=>{
        setPageContextType($fdaa4277f20d9667$export$a905239756c1fbae(location));
    }, [
        location
    ]);
    return pageContextType;
};
const $fdaa4277f20d9667$var$shuffleStarters = (arr)=>{
    const copiedArr = [
        ...arr
    ];
    // Shuffle array using Fisher-Yates algorithm
    for(let i = arr.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [copiedArr[i], copiedArr[j]] = [
            copiedArr[j],
            copiedArr[i]
        ];
    }
    return copiedArr;
};
const $fdaa4277f20d9667$export$82bea1a28fda43c1 = (starters, num)=>{
    // Return the first `num` items
    return $fdaa4277f20d9667$var$shuffleStarters(starters).slice(0, num);
};
const $fdaa4277f20d9667$var$getIconAndLabelForStarter = (labelType)=>{
    switch(labelType){
        case 'be-productive':
            return {
                icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cyLm6))), {
                    label: ""
                }),
                label: (0, $kj1we.default).beProductiveLabel
            };
        case 'stay-up-to-date':
            return {
                icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cyLm6))), {
                    label: ""
                }),
                label: (0, $kj1we.default).stayUpToDateLabel
            };
        case 'summarize-content':
            return {
                icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MNkP))), {
                    label: ""
                }),
                label: (0, $kj1we.default).summarizeContentLabel
            };
        case 'rephrase-content':
            return {
                icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MNkP))), {
                    label: ""
                }),
                label: (0, $kj1we.default).rephraseContentLabel
            };
        case 'draft-content':
            return {
                icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MNkP))), {
                    label: ""
                }),
                label: (0, $kj1we.default).draftContentLabel
            };
        case 'find-information':
            return {
                icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                    label: ""
                }),
                label: (0, $kj1we.default).findInformationLabel
            };
        case 'find-people':
            return {
                icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                    label: ""
                }),
                label: (0, $kj1we.default).findPeopleLabel
            };
        case 'code-search':
            return {
                icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                    label: ""
                }),
                label: (0, $kj1we.default).codeSearchLabel
            };
        case 'measure-productivity':
            return {
                icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cyLm6))), {
                    label: ""
                }),
                label: (0, $kj1we.default).measureProductivityLabel
            };
        case 'get-answers':
            return {
                icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                    label: ""
                }),
                label: (0, $kj1we.default).getAnswersLabel
            };
        case 'check-status':
            return {
                icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fNJG8))), {
                    label: ""
                }),
                label: (0, $kj1we.default).checkStatusLabel
            };
        case 'summarize-information':
            return {
                icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))), {
                    label: ""
                }),
                label: (0, $kj1we.default).summarizeInformationLabel
            };
        case 'analyze-content':
            return {
                icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))), {
                    label: ""
                }),
                label: (0, $kj1we.default).analyzeContentLabel
            };
        case 'summarize-code':
            return {
                icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TWiP))), {
                    label: ""
                }),
                label: (0, $kj1we.default).summarizeCodeLabel
            };
        case 'manage-settings':
            return {
                icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($l8mxb))), {
                    label: ""
                }),
                label: (0, $kj1we.default).manageSettingsLabel
            };
        case 'automation-rule':
            return {
                icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fIcbd))), {
                    label: ""
                }),
                label: (0, $kj1we.default).automationRuleLabel
            };
        default:
            return {
                icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cyLm6))), {
                    label: ""
                }),
                label: (0, $kj1we.default).beProductiveLabel
            };
    }
};
// default to fetching 3 dynamic starters
const $fdaa4277f20d9667$var$DYNAMIC_STARTERS_COUNT = 3;
const $fdaa4277f20d9667$export$65b45f3b39cd6930 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(38);
    const { numStarters: numStarters, dynamicStartersConfig: dynamicStartersConfig, assistanceServiceParams: assistanceServiceParams } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const pageContextType = $fdaa4277f20d9667$export$bc4bf2ff8e40b690();
    const location = (0, $codiQ.useWindowLocation)();
    const t1 = dynamicStartersConfig?.enabled && !!assistanceServiceParams;
    let t2;
    if ($[0] !== assistanceServiceParams) {
        t2 = assistanceServiceParams || {
            touchpointSource: "",
            product: "",
            experienceId: "",
            siteId: ""
        };
        $[0] = assistanceServiceParams;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== location || $[3] !== pageContextType || $[4] !== t1 || $[5] !== t2) {
        t3 = {
            contentUrl: location,
            pageContextType: pageContextType,
            showConvoStarters: t1,
            assistanceServiceParams: t2
        };
        $[2] = location;
        $[3] = pageContextType;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const { convoStarters: dynamicStarterActions, isLoading: isDynamicStarterActionsLoading } = (0, $30mnF.useFetchConvoStarters)(t3);
    const t4 = $fdaa4277f20d9667$export$c6a4ebf596b0c08a[pageContextType];
    let t5;
    if ($[7] !== formatMessage || $[8] !== t4) {
        let t6;
        if ($[10] !== formatMessage) {
            t6 = (starter)=>({
                    labelType: starter.labelType,
                    message: formatMessage(starter.message),
                    type: "static"
                });
            $[10] = formatMessage;
            $[11] = t6;
        } else t6 = $[11];
        t5 = t4.map(t6);
        $[7] = formatMessage;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    const contextualStarters = t5;
    const staticStarters = contextualStarters;
    let t6;
    if ($[12] !== staticStarters) {
        t6 = staticStarters.reduce($fdaa4277f20d9667$var$_temp, {});
        $[12] = staticStarters;
        $[13] = t6;
    } else t6 = $[13];
    const groupedStarters = t6;
    let t7;
    if ($[14] !== groupedStarters) {
        t7 = Object.entries(groupedStarters).map($fdaa4277f20d9667$var$_temp6);
        $[14] = groupedStarters;
        $[15] = t7;
    } else t7 = $[15];
    const conversationStarterActions = t7;
    let t8;
    if ($[16] !== formatMessage || $[17] !== groupedStarters) {
        t8 = Object.entries(groupedStarters).map((t9)=>{
            const [, starters_0] = t9;
            const { icon: icon, label: label } = $fdaa4277f20d9667$var$getIconAndLabelForStarter(starters_0[0].labelType);
            return {
                id: "convo-starter",
                title: formatMessage(label),
                icon: ()=>icon,
                onClick: $fdaa4277f20d9667$var$_temp7,
                children: starters_0.map((starter_2)=>{
                    const starterHasPlaceholder_0 = starter_2.message.includes("`");
                    return {
                        id: "convo-starter",
                        title: starter_2.message,
                        icon: ()=>icon,
                        onClick: $fdaa4277f20d9667$var$_temp8,
                        type: "convo-starter-action",
                        handleType: (0, $6Htct.HandleActionType).Chat,
                        ...starterHasPlaceholder_0 ? {
                            dynamicPrompt: starter_2.message
                        } : {
                            staticPrompt: starter_2.message
                        },
                        starterType: "static"
                    };
                }),
                handleType: (0, $6Htct.HandleActionType).Nested,
                type: "convo-starter-action"
            };
        });
        $[16] = formatMessage;
        $[17] = groupedStarters;
        $[18] = t8;
    } else t8 = $[18];
    const nestedConversationStarterActions = t8;
    const numStartersToReturn = numStarters ?? conversationStarterActions.length + dynamicStarterActions.length;
    const numNestedStartersToReturn = numStarters ?? nestedConversationStarterActions.length;
    dynamicStartersConfig?.enabled;
    let t9;
    bb0: {
        if (!dynamicStartersConfig?.enabled) {
            let t10;
            if ($[19] !== conversationStarterActions || $[20] !== numStartersToReturn) {
                t10 = $fdaa4277f20d9667$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn);
                $[19] = conversationStarterActions;
                $[20] = numStartersToReturn;
                $[21] = t10;
            } else t10 = $[21];
            t9 = t10;
            break bb0;
        }
        if (isDynamicStarterActionsLoading) {
            let t10;
            if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
                t10 = [];
                $[22] = t10;
            } else t10 = $[22];
            t9 = t10;
            break bb0;
        }
        if (dynamicStarterActions.length >= numStartersToReturn) {
            let t10;
            if ($[23] !== dynamicStarterActions || $[24] !== numStartersToReturn) {
                t10 = dynamicStarterActions.slice(0, numStartersToReturn);
                $[23] = dynamicStarterActions;
                $[24] = numStartersToReturn;
                $[25] = t10;
            } else t10 = $[25];
            t9 = t10;
            break bb0;
        }
        let t10;
        if ($[26] !== conversationStarterActions || $[27] !== dynamicStarterActions || $[28] !== numStartersToReturn) {
            t10 = [
                ...dynamicStarterActions,
                ...$fdaa4277f20d9667$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn - dynamicStarterActions.length)
            ];
            $[26] = conversationStarterActions;
            $[27] = dynamicStarterActions;
            $[28] = numStartersToReturn;
            $[29] = t10;
        } else t10 = $[29];
        t9 = t10;
    }
    const randomizedConversationStarterActions = t9;
    let t10;
    if ($[30] !== nestedConversationStarterActions || $[31] !== numNestedStartersToReturn) {
        t10 = $fdaa4277f20d9667$export$82bea1a28fda43c1(nestedConversationStarterActions, numNestedStartersToReturn);
        $[30] = nestedConversationStarterActions;
        $[31] = numNestedStartersToReturn;
        $[32] = t10;
    } else t10 = $[32];
    const randomizedNestedConversationStarterActions = t10;
    const t11 = Math.min($fdaa4277f20d9667$var$DYNAMIC_STARTERS_COUNT, numStartersToReturn);
    let t12;
    if ($[33] !== isDynamicStarterActionsLoading || $[34] !== randomizedConversationStarterActions || $[35] !== randomizedNestedConversationStarterActions || $[36] !== t11) {
        t12 = {
            conversationStarterActions: randomizedConversationStarterActions,
            nestedConversationStarterActions: randomizedNestedConversationStarterActions,
            getRandomStarters: $fdaa4277f20d9667$export$82bea1a28fda43c1,
            isDynamicStarterActionsLoading: isDynamicStarterActionsLoading,
            numDynamicStarterActionsLoading: t11
        };
        $[33] = isDynamicStarterActionsLoading;
        $[34] = randomizedConversationStarterActions;
        $[35] = randomizedNestedConversationStarterActions;
        $[36] = t11;
        $[37] = t12;
    } else t12 = $[37];
    return t12;
} : ({ numStarters: numStarters, dynamicStartersConfig: dynamicStartersConfig, assistanceServiceParams: assistanceServiceParams })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const pageContextType = $fdaa4277f20d9667$export$bc4bf2ff8e40b690();
    const location = (0, $codiQ.useWindowLocation)();
    const { convoStarters: dynamicStarterActions, isLoading: isDynamicStarterActionsLoading } = (0, $30mnF.useFetchConvoStarters)({
        contentUrl: location,
        pageContextType: pageContextType,
        showConvoStarters: dynamicStartersConfig?.enabled && !!assistanceServiceParams,
        // hacky workaround for consumers that don't need dynamic starters (and therfore don't pass in assistanceServiceParams)
        assistanceServiceParams: assistanceServiceParams || {
            touchpointSource: '',
            product: '',
            experienceId: '',
            siteId: ''
        }
    });
    const staticStarters = (0, $42omo.useMemo)(()=>{
        const contextualStarters = $fdaa4277f20d9667$export$c6a4ebf596b0c08a[pageContextType].map((starter)=>{
            return {
                labelType: starter.labelType,
                message: formatMessage(starter.message),
                type: 'static'
            };
        });
        return contextualStarters;
    }, [
        pageContextType,
        formatMessage
    ]);
    const groupedStarters = (0, $42omo.useMemo)(()=>staticStarters.reduce((acc, starter_0)=>{
            if (!starter_0.labelType) return acc;
            acc[starter_0.labelType] = [
                ...acc[starter_0.labelType] || [],
                starter_0
            ];
            return acc;
        }, {}), [
        staticStarters
    ]);
    // Use this to get conversation starter actions that are not nested (e.g. for Sidebar)
    const conversationStarterActions = (0, $42omo.useMemo)(()=>Object.entries(groupedStarters).map(([, starters])=>{
            // If there is only one starter in the group, return as a single chat action, otherwise return one of the nested items to use as a starter
            if (starters.length === 1) {
                const starter_1 = starters[0];
                const starterHasPlaceholder = starter_1.message.includes('`');
                return {
                    id: 'convo-starter',
                    title: starter_1.message,
                    icon: ()=>/*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                            label: ""
                        }),
                    onClick: ()=>{},
                    handleType: (0, $6Htct.HandleActionType).Chat,
                    children: [],
                    ...starterHasPlaceholder ? {
                        dynamicPrompt: starter_1.message
                    } : {
                        staticPrompt: starter_1.message
                    },
                    type: 'convo-starter-action',
                    starterType: 'static'
                };
            } else {
                //Grab a random starter from the group to use
                const randomIndex = Math.floor(Math.random() * starters.length);
                const randomStarter = starters[randomIndex];
                const randomStarterHasPlaceholder = randomStarter.message.includes('`');
                return {
                    id: `convo-starter`,
                    title: randomStarter.message,
                    icon: ()=>/*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                            label: ""
                        }),
                    onClick: ()=>{},
                    handleType: (0, $6Htct.HandleActionType).Chat,
                    ...randomStarterHasPlaceholder ? {
                        dynamicPrompt: randomStarter.message
                    } : {
                        staticPrompt: randomStarter.message
                    },
                    type: 'convo-starter-action',
                    starterType: 'static'
                };
            }
        }), [
        groupedStarters
    ]);
    // Use this to get conversation starter actions that are nested (e.g. for Full Screen)
    const nestedConversationStarterActions = (0, $42omo.useMemo)(()=>Object.entries(groupedStarters).map(([, starters_0])=>{
            const { icon: icon, label: label } = $fdaa4277f20d9667$var$getIconAndLabelForStarter(starters_0[0].labelType);
            return {
                id: 'convo-starter',
                title: formatMessage(label),
                icon: ()=>icon,
                onClick: ()=>{},
                children: starters_0.map((starter_2)=>{
                    const starterHasPlaceholder_0 = starter_2.message.includes('`');
                    return {
                        id: 'convo-starter',
                        title: starter_2.message,
                        icon: ()=>icon,
                        onClick: ()=>{},
                        type: 'convo-starter-action',
                        handleType: (0, $6Htct.HandleActionType).Chat,
                        ...starterHasPlaceholder_0 ? {
                            dynamicPrompt: starter_2.message
                        } : {
                            staticPrompt: starter_2.message
                        },
                        starterType: 'static'
                    };
                }),
                handleType: (0, $6Htct.HandleActionType).Nested,
                type: 'convo-starter-action'
            };
        }), [
        groupedStarters,
        formatMessage
    ]);
    const numStartersToReturn = numStarters ?? conversationStarterActions.length + dynamicStarterActions.length;
    // dynamic starter actions are not included in nested use case
    const numNestedStartersToReturn = numStarters ?? nestedConversationStarterActions.length;
    const randomizedConversationStarterActions = (0, $42omo.useMemo)(()=>{
        if (!dynamicStartersConfig?.enabled) return $fdaa4277f20d9667$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn);
        if (isDynamicStarterActionsLoading) return [];
        if (dynamicStarterActions.length >= numStartersToReturn) return dynamicStarterActions.slice(0, numStartersToReturn);
        // prioritizes dynamic starters, and then randomizes the static starters
        return [
            ...dynamicStarterActions,
            ...$fdaa4277f20d9667$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn - dynamicStarterActions.length)
        ];
    }, [
        conversationStarterActions,
        numStartersToReturn,
        dynamicStarterActions,
        isDynamicStarterActionsLoading,
        dynamicStartersConfig?.enabled
    ]);
    const randomizedNestedConversationStarterActions = (0, $42omo.useMemo)(()=>{
        return $fdaa4277f20d9667$export$82bea1a28fda43c1(nestedConversationStarterActions, numNestedStartersToReturn);
    }, [
        nestedConversationStarterActions,
        numNestedStartersToReturn
    ]);
    return {
        conversationStarterActions: randomizedConversationStarterActions,
        nestedConversationStarterActions: randomizedNestedConversationStarterActions,
        getRandomStarters: $fdaa4277f20d9667$export$82bea1a28fda43c1,
        isDynamicStarterActionsLoading: isDynamicStarterActionsLoading,
        numDynamicStarterActionsLoading: Math.min($fdaa4277f20d9667$var$DYNAMIC_STARTERS_COUNT, numStartersToReturn)
    };
};
function $fdaa4277f20d9667$var$_temp(acc, starter_0) {
    if (!starter_0.labelType) return acc;
    acc[starter_0.labelType] = [
        ...acc[starter_0.labelType] || [],
        starter_0
    ];
    return acc;
}
function $fdaa4277f20d9667$var$_temp2() {
    return /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
        label: ""
    });
}
function $fdaa4277f20d9667$var$_temp3() {}
function $fdaa4277f20d9667$var$_temp4() {
    return /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
        label: ""
    });
}
function $fdaa4277f20d9667$var$_temp5() {}
function $fdaa4277f20d9667$var$_temp6(t0) {
    const [, starters] = t0;
    if (starters.length === 1) {
        const starter_1 = starters[0];
        const starterHasPlaceholder = starter_1.message.includes("`");
        return {
            id: "convo-starter",
            title: starter_1.message,
            icon: $fdaa4277f20d9667$var$_temp2,
            onClick: $fdaa4277f20d9667$var$_temp3,
            handleType: (0, $6Htct.HandleActionType).Chat,
            children: [],
            ...starterHasPlaceholder ? {
                dynamicPrompt: starter_1.message
            } : {
                staticPrompt: starter_1.message
            },
            type: "convo-starter-action",
            starterType: "static"
        };
    } else {
        const randomIndex = Math.floor(Math.random() * starters.length);
        const randomStarter = starters[randomIndex];
        const randomStarterHasPlaceholder = randomStarter.message.includes("`");
        return {
            id: "convo-starter",
            title: randomStarter.message,
            icon: $fdaa4277f20d9667$var$_temp4,
            onClick: $fdaa4277f20d9667$var$_temp5,
            handleType: (0, $6Htct.HandleActionType).Chat,
            ...randomStarterHasPlaceholder ? {
                dynamicPrompt: randomStarter.message
            } : {
                staticPrompt: randomStarter.message
            },
            type: "convo-starter-action",
            starterType: "static"
        };
    }
}
function $fdaa4277f20d9667$var$_temp7() {}
function $fdaa4277f20d9667$var$_temp8() {}
module.exports["usePageContextType"] = $fdaa4277f20d9667$export$bc4bf2ff8e40b690;
module.exports["useRovoConversationStarters"] = $fdaa4277f20d9667$export$65b45f3b39cd6930;

});

parcelRegister("30mnF", function(module, exports) {
// adapted from: platform/packages/insights-ai-platform/ai-smart-button/src/ui/ai-actions/hooks/useFetchConvoStarters.ts

var $42omo = parcelRequire("42omo");


var $lDwiy = parcelRequire("lDwiy");


var $16lEl = parcelRequire("16lEl");


var $kIvLT = parcelRequire("kIvLT");


var $9eLw5 = parcelRequire("9eLw5");


var $h26dv = parcelRequire("h26dv");


var $6Htct = parcelRequire("6Htct");


var $ahwTE = parcelRequire("ahwTE");


var $71TxW = parcelRequire("71TxW");

const $307eca84f066701b$var$mapToConversationActionNew = (starterObject)=>{
    return {
        id: 'convo-starter',
        title: starterObject.starter,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                label: ""
            }),
        staticPrompt: starterObject.starter,
        handleType: (0, $6Htct.HandleActionType).Chat,
        starterType: 'dynamic',
        jtbdCategory: starterObject.jtbd_category,
        agent: undefined,
        type: 'convo-starter-action'
    };
};
const $307eca84f066701b$export$460b2fd9dae847fd = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId }, contentUrl: contentUrl, pageContextType: pageContextType, showConvoStarters: showConvoStarters = false })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const timingRef = (0, $42omo.useRef)(null);
    const contentAri = (0, $42omo.useMemo)(()=>(0, $71TxW.getContentAri)(siteId, contentUrl, pageContextType), [
        siteId,
        contentUrl,
        pageContextType
    ]);
    // TODO ASIMO-2398: experiment cleanup
    const urlDebugInfo = (0, $42omo.useMemo)(()=>{
        try {
            const url = new URL(contentUrl);
            return {
                pathSegmentCount: url.pathname.split('/').filter(Boolean).length,
                hasQueryParams: url.search.length > 0,
                protocol: url.protocol
            };
        } catch  {
            return {
                pathSegmentCount: 0,
                hasQueryParams: false,
                protocol: 'invalid'
            };
        }
    }, [
        contentUrl
    ]);
    const isPageContextTypeSupported = (0, $ahwTE.isPageContextTypeSupportedForDynamicStarters)(pageContextType);
    const isEligibleContext = isPageContextTypeSupported && contentAri !== null;
    const isFeatureEnabled = showConvoStarters && isEligibleContext;
    // TODO ASIMO-2398: experiment cleanup
    (0, $42omo.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'called',
            actionSubject: 'useFetchConvoStarters',
            attributes: {
                showConvoStarters: showConvoStarters,
                isPageContextTypeSupported: isPageContextTypeSupported,
                isEligibleContext: isEligibleContext,
                isFeatureEnabled: isFeatureEnabled,
                pageContextType: String(pageContextType),
                hasContentAri: contentAri !== null,
                contentAri: contentAri,
                urlStructure: urlDebugInfo
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { data: convoStarters, isFetching: isLoading, error: fetchError } = (0, $9eLw5.useQuery)({
        enabled: isFeatureEnabled,
        queryKey: [
            'dynamicConvoStarters',
            contentAri ?? contentUrl
        ],
        queryFn: async ()=>{
            // Custom performance tracking for dynamic starters experiment to analyze on Statsig.
            // Confluence ui taskSuccess events aren't sent to Statsig.
            timingRef.current = {
                startTime: performance.now(),
                sent: false,
                pageContextType: String(pageContextType)
            };
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS,
                name: (0, $16lEl.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'started',
                actionSubject: 'fetchConvoStarters',
                attributes: {
                    pageContextType: timingRef.current.pageContextType
                }
            });
            const response = await assistanceService.getDynamicConvoStartersNew({
                ai_feature_input: {
                    // safe to assert: query is disabled (enabled condition) when contentAri is null
                    documents: [
                        {
                            ari: contentAri
                        }
                    ]
                }
            });
            // Since we only request one document, we should get exactly one result
            const result = response?.ai_feature_output?.results?.[0];
            if (!result) throw new Error('Expected one result in API response but received none');
            if (result.error) {
                const errorType = result.error.error_type;
                // expected failures (HYDRATION_ERROR) are silently filtered
                if (errorType === 'HYDRATION_ERROR') return [];
                throw new Error(`[${errorType}] ${result.error.message}`);
            }
            if (!result.convo_starters.length) return [];
            return result.convo_starters.map((starter)=>$307eca84f066701b$var$mapToConversationActionNew(starter));
        },
        onSuccess: (data)=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS
            });
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'succeeded',
                    actionSubject: 'fetchConvoStarters',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime,
                        startersCount: data?.length ?? 0,
                        pageContextType: timingRef.current.pageContextType
                    }
                });
                timingRef.current.sent = true;
            }
        },
        onError: (error)=>{
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'failed',
                    actionSubject: 'fetchConvoStarters',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime,
                        errorMessage: error.message,
                        pageContextType: timingRef.current.pageContextType
                    }
                });
                timingRef.current.sent = true;
            }
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS,
                error: error
            });
        }
    });
    // Track cancellations when component unmounts during fetch
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'cancelled',
                    actionSubject: 'fetchConvoStarters',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime,
                        pageContextType: timingRef.current.pageContextType
                    }
                });
                timingRef.current.sent = true;
            }
        };
    }, [
        sendAnalyticsEvent
    ]);
    return (0, $42omo.useMemo)(()=>({
            convoStarters: convoStarters ?? [],
            isLoading: isLoading,
            error: fetchError ?? undefined
        }), [
        convoStarters,
        isLoading,
        fetchError
    ]);
});
module.exports["useFetchConvoStarters"] = $307eca84f066701b$export$460b2fd9dae847fd;

});

parcelRegister("kj1we", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $0eda44d105fdc1cc$var$_default_1 = (0, $aXWIB.defineMessages)({
    // Conversation starter labels
    beProductiveLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.be-productive",
        defaultMessage: "Be productive"
    },
    stayUpToDateLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.stay-up-to-date",
        defaultMessage: "Stay up-to-date"
    },
    summarizeContentLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.summarize-content",
        defaultMessage: "Summarize content"
    },
    rephraseContentLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.rephrase-content",
        defaultMessage: "Rephrase content"
    },
    draftContentLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.draft-content",
        defaultMessage: "Draft content"
    },
    findInformationLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.find-information",
        defaultMessage: "Find information"
    },
    findPeopleLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.find-people",
        defaultMessage: "Find people"
    },
    codeSearchLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.code-search",
        defaultMessage: "Code search"
    },
    measureProductivityLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.measure-productivity",
        defaultMessage: "Measure productivity"
    },
    getAnswersLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.get-answers",
        defaultMessage: "Get answers"
    },
    checkStatusLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.check-status",
        defaultMessage: "Check status"
    },
    summarizeInformationLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.summarize-information",
        defaultMessage: "Summarize information"
    },
    analyzeContentLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.analyze-content",
        defaultMessage: "Analyze content"
    },
    summarizeCodeLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.summarize-code",
        defaultMessage: "Summarize code"
    },
    automationRuleLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.automation-rule",
        defaultMessage: "Automation rule"
    },
    manageSettingsLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.manage-settings",
        defaultMessage: "Manage settings"
    },
    // BITBUCKET_CREATE_PULL_REQUESTS
    bitbucketCreatePullRequestsPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-create-pull-requests.starter-1",
        defaultMessage: "Suggest reviewers for this pull request"
    },
    // BITBUCKET_PULL_REQUESTS
    bitbucketPullRequestsPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-1",
        defaultMessage: "Summarize this pull request"
    },
    bitbucketPullRequestsPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-2",
        defaultMessage: "Explain the code changes to me."
    },
    bitbucketPullRequestsPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-3",
        defaultMessage: "Summarize the comments on this pull request"
    },
    bitbucketPullRequestsPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-4",
        defaultMessage: "Explain the code changes"
    },
    bitbucketPullRequestsPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-5-1",
        defaultMessage: "Summarize the build logs"
    },
    bitbucketPullRequestsPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-6",
        defaultMessage: "Suggest reviewers for this pull request"
    },
    // BITBUCKET_REPOSITORY_SOURCE
    bitbucketRepositorySourcePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-1",
        defaultMessage: "Explain this file"
    },
    bitbucketRepositorySourcePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-2",
        defaultMessage: "What are the pull requests authored by `person`?"
    },
    bitbucketRepositorySourcePrompt3: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-3",
        defaultMessage: " What APIs or modules do these files interact with?"
    },
    bitbucketRepositorySourcePrompt4: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-4",
        defaultMessage: "Find pull requests authored by `person`"
    },
    bitbucketRepositorySourcePrompt5: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-5",
        defaultMessage: "Find APIs that these files interact with"
    },
    // BITBUCKET_PIPELINES
    bitbucketPipelinePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pipelines.starter-1-1",
        defaultMessage: "Summarize the build logs"
    },
    bitbucketPipelinePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pipelines.starter-2",
        defaultMessage: "What is the status of the `build`?"
    },
    // BITBUCKET_HOME
    bitbucketPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-1",
        defaultMessage: "What are the pull requests authored by `person`?"
    },
    bitbucketPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-2",
        defaultMessage: "What are the open PRs for the current Jira sprint?"
    },
    bitbucketPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-3",
        defaultMessage: "Has `Jira work item` been deployed?"
    },
    bitbucketPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-4",
        defaultMessage: "Who are the reviewers on this `Pull request`?"
    },
    bitbucketPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-5",
        defaultMessage: "Find pull requests authored by `person`"
    },
    bitbucketPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-6",
        defaultMessage: "Check deployment status of `Jira work item`"
    },
    bitbucketPrompt7: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-7",
        defaultMessage: "Find reviewers of `pull request`"
    },
    // CONFLUENCE_HOME
    confluenceHomePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-1",
        defaultMessage: "Is there any new activity on pages I've written?"
    },
    confluenceHomePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-2",
        defaultMessage: "Are there any new comments mentioning me?"
    },
    confluenceHomePrompt3: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-3",
        defaultMessage: "Summarize the most recently published pages in this space."
    },
    confluenceHomePrompt4: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-4",
        defaultMessage: "Summarize my contributions to pages from last week."
    },
    confluenceHomePrompt5: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-5",
        defaultMessage: "Can you take this `page` and write it in a less technical way?"
    },
    confluenceHomePrompt6: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-6",
        defaultMessage: "Create a game plan template for project management."
    },
    confluenceHomePrompt7: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-7",
        defaultMessage: "What research do we have on common customer problems?"
    },
    confluenceHomePrompt8: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-8",
        defaultMessage: "Has anyone on my team published any new pages this week?"
    },
    confluenceHomePrompt9: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-9",
        defaultMessage: "Has `person` published any new pages this week?"
    },
    confluenceHomePrompt10: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-10",
        defaultMessage: "Has `person` commented on any pages that I've published?"
    },
    confluenceHomePrompt11: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-11",
        defaultMessage: "What are the key takeaways from `page`?"
    },
    confluenceHomePrompt12: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-12",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_PAGE_VIEW & CONFLUENCE_BLOG_VIEW
    confluencePageViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-1",
        defaultMessage: "Summarize what I'm looking at."
    },
    confluencePageViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-2",
        defaultMessage: "Summarize the comments on this page."
    },
    confluencePageViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-3",
        defaultMessage: "Explain this page to me like I'm a beginner."
    },
    confluencePageViewPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-4",
        defaultMessage: "Who wrote this page and what team are they on?"
    },
    confluencePageViewPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-5",
        defaultMessage: "Has anything on this page changed in the last week?"
    },
    confluencePageViewPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-6",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_PAGE_EDIT & CONFLUENCE_BLOG_EDIT
    confluencePageEditPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-1",
        defaultMessage: "Can you improve the writing on this page?"
    },
    confluencePageEditPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-2",
        defaultMessage: "Write an executive summary for this page."
    },
    confluencePageEditPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-3",
        defaultMessage: "Give me links to some other relevant pages."
    },
    confluencePageEditPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-4",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_WHITEBOARD
    confluenceWhiteboardPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-1",
        defaultMessage: "Summarize what I'm looking at."
    },
    confluenceWhiteboardPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-2",
        defaultMessage: "Highlight any patterns or trends visible here."
    },
    confluenceWhiteboardPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-3",
        defaultMessage: "Identify any key action items or decisions captured in this whiteboard."
    },
    confluenceWhiteboardPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-4",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_HOME
    jiraHomePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-1",
        defaultMessage: "Find Jira issues that have been updated this week."
    },
    jiraHomePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-2",
        defaultMessage: "What Jira issues are the highest priority?"
    },
    jiraHomePrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-3",
        defaultMessage: "What Jira issues have comments mentioning me?"
    },
    jiraHomePrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-4",
        defaultMessage: "Summarize the comments on `Jira issue`."
    },
    jiraHomePrompt5: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-5",
        defaultMessage: "Create a description template for user stories."
    },
    jiraHomePrompt6: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-6",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_ISSUE_VIEW
    jiraIssueViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-issue-view.starter-1",
        defaultMessage: "Are there any similar Jira issues to this one?"
    },
    jiraIssueViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-issue-view.starter-2",
        defaultMessage: "How could I improve the description?"
    },
    jiraIssueViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-issue-view.starter-3",
        defaultMessage: "What labels could I add to this issue?"
    },
    jiraIssueViewPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-issue-view.starter-4",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_PROJECT
    jiraProjectPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-1",
        defaultMessage: "What work hasn\u2019t been picked up in a while?"
    },
    jiraProjectPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-2",
        defaultMessage: "Are any Jira issues blocked?"
    },
    jiraProjectPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-3",
        defaultMessage: "List Jira issues that are currently \u201CIn Progress\u201D and group them by assignee."
    },
    jiraProjectPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-4",
        defaultMessage: "How many issues are assigned to `person`?"
    },
    jiraProjectPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-5",
        defaultMessage: "Has `person` commented on any Jira issues in this sprint?"
    },
    jiraProjectPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-6",
        defaultMessage: "What Jira issues are unassigned?"
    },
    jiraProjectPrompt7: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-7",
        defaultMessage: "What Jira issues have been open the longest?"
    },
    jiraProjectPrompt8: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-8",
        defaultMessage: "Who has the most tasks?"
    },
    jiraProjectPrompt9: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-9",
        defaultMessage: "Find and group similar Jira issues."
    },
    jiraProjectPrompt10: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-10",
        defaultMessage: "Are there any Jira issues not connected to a parent issue?"
    },
    jiraProjectPrompt11: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-11",
        defaultMessage: "Take `Jira issue` description and align it to best-practice."
    },
    jiraProjectPrompt12: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-12",
        defaultMessage: "Summarize the comments on `Jira issue`."
    },
    jiraProjectPrompt13: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-13",
        defaultMessage: "Create a description template for user stories."
    },
    jiraProjectPrompt14: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-14",
        defaultMessage: "What should I work on next?"
    },
    // JSM_INCIDENT_VIEW
    jsmIncidentViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-1",
        defaultMessage: "Find people who can help resolve this incident"
    },
    jsmIncidentViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-2",
        defaultMessage: "Are there any ongoing incidents?"
    },
    jsmIncidentViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-3",
        defaultMessage: "Create a post-incident review (PIR)"
    },
    // JSM_INCIDENT_LIST_VIEW
    jsmIncidentListViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-1",
        defaultMessage: "Are there any ongoing incidents?"
    },
    jsmIncidentListViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-2",
        defaultMessage: "Get me the open high priority incidents"
    },
    jsmIncidentListViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-3",
        defaultMessage: "Are there any open alerts?"
    },
    // JSM_ALERT_VIEW (Alert details page)
    jsmAlertViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-1",
        defaultMessage: "Find open alerts"
    },
    jsmAlertViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-2",
        defaultMessage: "Investigate this alert"
    },
    jsmAlertViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-3",
        defaultMessage: "Are there any ongoing incidents?"
    },
    // JSM_ALERT_LIST_VIEW (Alert list page)
    jsmAlertListViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-1",
        defaultMessage: "Find open alerts"
    },
    jsmAlertListViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-2",
        defaultMessage: "Find recently closed alerts"
    },
    jsmAlertListViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-3",
        defaultMessage: "Are there any ongoing incidents?"
    },
    // JSM_ALERT_GROUP_DETAIL_VIEW (Alert group details page)
    jsmAlertGroupDetailViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-1",
        defaultMessage: "Find open alerts"
    },
    jsmAlertGroupDetailViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-2",
        defaultMessage: "Find recently closed alerts"
    },
    jsmAlertGroupDetailViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-3",
        defaultMessage: "Are there any ongoing incidents?"
    },
    // ATLAS HOME
    atlasHomePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-1",
        defaultMessage: "What Confluence pages have I contributed to recently?"
    },
    atlasHomePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-2",
        defaultMessage: "Find all Jira tickets that are assigned to me."
    },
    atlasHomePrompt3: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-3",
        defaultMessage: "What is our travel policy?"
    },
    atlasHomePrompt4: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-4",
        defaultMessage: "Draft a Confluence page for a marketing campaign."
    },
    atlasHomePrompt5: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-5",
        defaultMessage: "How can I create a project timeline?"
    },
    atlasHomePrompt6: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-6",
        defaultMessage: "Write a follow up email to potential clients."
    },
    atlasHomePrompt7: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-7",
        defaultMessage: "What should I work on next?"
    },
    // FOCUS
    focusPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus.starter-1",
        defaultMessage: "Summarize my focus areas."
    },
    focusPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.focus.starter-2",
        defaultMessage: "Identify gaps and highlight risks."
    },
    // FOCUS_FOCUS_AREA_PAGE
    focusAreaPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-area.starter-1",
        defaultMessage: "Summarize this focus area."
    },
    // FOCUS_FOCUS_AREA_GOAL_VIEW
    focusAreaGoalPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-area-goal.starter-1",
        defaultMessage: "Summarize the goals linked to this focus area."
    },
    // FOCUS_FOCUS_AREA_WORK_VIEW
    focusAreaWorkPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-area-work.starter-1",
        defaultMessage: "Summarize the work linked to this focus area."
    },
    // FOCUS_FOR_YOU
    focusForYouPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-for-you.starter-1",
        defaultMessage: "Summarize my focus areas."
    },
    // SAC
    sacPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.sac.starter-1",
        defaultMessage: "How do I manage settings?"
    },
    sacPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.sac.starter-2",
        defaultMessage: "How do I find information?"
    },
    sacPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.sac.starter-3",
        defaultMessage: "How do I create an automation rule?"
    },
    // TRELLO_BOARD (board/universal rovo button)
    trelloBoardPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.trello-board.starter-1",
        defaultMessage: "Summarize this board."
    },
    trelloBoardPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.trello-board.starter-2",
        defaultMessage: "Suggest ways to organize this board."
    },
    trelloBoardPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.trello-board.starter-3",
        defaultMessage: "What should my top 3 priorities be today?"
    },
    // TRELLO_CARD (cardback)
    trelloCardPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.trello-card.starter-1",
        defaultMessage: "Summarize this card."
    },
    trelloCardPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.trello-card.starter-2",
        defaultMessage: "Find work related to this card."
    },
    trelloCardPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.trello-card.starter-3",
        defaultMessage: "Suggest improvements for this card's description."
    },
    // UNKNOWN
    unknownPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.unknown.starter-1",
        defaultMessage: "Are any of my work items overdue?"
    },
    unknownPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.unknown.starter-2",
        defaultMessage: "What should I work on next?"
    },
    unknownPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.unknown.starter-3",
        defaultMessage: "Write an update about my week."
    }
});
var $0eda44d105fdc1cc$export$2e2bcd8739ae039 = $0eda44d105fdc1cc$var$_default_1;
module.exports["default"] = $0eda44d105fdc1cc$export$2e2bcd8739ae039;

});

parcelRegister("s5sAh", function(module, exports) {
/**
 * Onboarding holdout state (24h cooldown, max 3 exposures, don't show again after completion).
 * Uses AtlBrowserStorageLocal for persistence. If productionized, consider a more permanent
 * source (e.g. backend or user preferences).
 */ 
var $7MEbC = parcelRequire("7MEbC");

var $ccRXO = parcelRequire("ccRXO");


var $c4TO3 = parcelRequire("c4TO3");


var $cBi7Q = parcelRequire("cBi7Q");

const $61cbc002d66d4308$export$124df12a015901ba = 'rovoOnboardingHoldout';
const $61cbc002d66d4308$export$af9030d6dd88ec25 = 24 * (0, $cBi7Q.SECONDS_IN_HR) * (0, $cBi7Q.MS_IN_SECOND);
const $61cbc002d66d4308$export$a478a0028a108fe6 = 3;
const $61cbc002d66d4308$var$DEFAULT_HOLDOUT_STATE = {
    lastSeenAt: 0,
    exposureCount: 0,
    onboardingCompleted: false
};
async function $61cbc002d66d4308$export$4f0cb70940bf9c95() {
    try {
        const prefs = await (0, $7MEbC.getPreferences)();
        return Boolean(prefs?.[(0, $ccRXO.PreferenceCategory).Functional]);
    } catch  {
        return false;
    }
}
function $61cbc002d66d4308$var$parseState(raw) {
    if (raw === null) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed.lastSeenAt === 'number' && typeof parsed.exposureCount === 'number') return {
        lastSeenAt: parsed.lastSeenAt,
        exposureCount: Math.min(Math.max(0, Math.floor(parsed.exposureCount)), $61cbc002d66d4308$export$a478a0028a108fe6),
        onboardingCompleted: parsed.onboardingCompleted === true
    };
    return null;
}
function $61cbc002d66d4308$export$70098a1ba52d021f() {
    try {
        return $61cbc002d66d4308$var$parseState((0, $c4TO3.AtlBrowserStorageLocal).getItem($61cbc002d66d4308$export$124df12a015901ba));
    } catch  {
        return null;
    }
}
function $61cbc002d66d4308$export$89871c89a47e5ed3() {
    try {
        const raw = (0, $c4TO3.AtlBrowserStorageLocal).getItem($61cbc002d66d4308$export$124df12a015901ba);
        if (raw === null) return true;
        const state = $61cbc002d66d4308$var$parseState(raw);
        if (state === null) return false;
        if (state.onboardingCompleted || state.exposureCount >= $61cbc002d66d4308$export$a478a0028a108fe6) return false;
        return Date.now() - state.lastSeenAt >= $61cbc002d66d4308$export$af9030d6dd88ec25;
    } catch  {
        return false;
    }
}
function $61cbc002d66d4308$var$persistState(state) {
    try {
        (0, $c4TO3.AtlBrowserStorageLocal).setItem($61cbc002d66d4308$export$124df12a015901ba, JSON.stringify(state));
    } catch  {
    // AtlBrowserStorageLocal may be full or unavailable (e.g. private browsing in Safari)
    }
}
function $61cbc002d66d4308$export$47e4355399c5e75() {
    const state = $61cbc002d66d4308$export$70098a1ba52d021f() ?? $61cbc002d66d4308$var$DEFAULT_HOLDOUT_STATE;
    if (state.onboardingCompleted || state.exposureCount >= $61cbc002d66d4308$export$a478a0028a108fe6) return;
    $61cbc002d66d4308$var$persistState({
        ...state,
        lastSeenAt: Date.now(),
        exposureCount: state.exposureCount + 1
    });
}
function $61cbc002d66d4308$export$f6d2bc57e324a079() {
    const state = $61cbc002d66d4308$export$70098a1ba52d021f() ?? $61cbc002d66d4308$var$DEFAULT_HOLDOUT_STATE;
    $61cbc002d66d4308$var$persistState({
        ...state,
        lastSeenAt: Date.now(),
        onboardingCompleted: true
    });
}
module.exports["canPersistOnboardingHoldoutState"] = $61cbc002d66d4308$export$4f0cb70940bf9c95;
module.exports["passesOnboardingHoldout"] = $61cbc002d66d4308$export$89871c89a47e5ed3;
module.exports["recordOnboardingExposureForHoldout"] = $61cbc002d66d4308$export$47e4355399c5e75;
module.exports["recordOnboardingCompletedForHoldout"] = $61cbc002d66d4308$export$f6d2bc57e324a079;

});

parcelRegister("ajVP3", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $fFa3V = parcelRequire("fFa3V");


var $aXWIB = parcelRequire("aXWIB");


var $hTKp4 = parcelRequire("hTKp4");


var $fVUfS = parcelRequire("fVUfS");


var $dZoqB = parcelRequire("dZoqB");


var $eintH = parcelRequire("eintH");

const $63e36e003ba6b889$var$messages = (0, $aXWIB.defineMessages)({
    resizeSidePanelAriaLabel: {
        id: "ai-mate.conversation-assistant.split-layout.resize-side-panel-aria-label",
        defaultMessage: "Resize side panel"
    }
});
const $63e36e003ba6b889$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _vchhusvi _1wpz1fhb _4t3i1osq _1bsb1osq _1tkeidpf _1ul9idpf _1e0c1txw _2lx2vrvc _4cvr1fhb",
    leftPane: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1wpz1fhb _4t3i1osq _1tkeidpf _1ul9idpf _1e0c1txw _2lx21bp4 _4cvr1fhb",
    rightPanel: "_16jlidpf _1o9zidpf _i0dl1wug _1reo15vq _18m915vq _1wpz1fhb _4t3i1osq _1tkeidpf _1ul9idpf _1e0c1txw _2lx21bp4 _4cvr1fhb _t6vde4h9 _1p3lnqa1 _5wra1l7x",
    resizeHandle: "_19itglyw _v5642hjt _1bsb1y44 _1wpz1fhb _kqswh2mm _80om11mm _bfhk1j28 _qc5o2hjt _aetrb3bt _18postnw _19do1ssb _15l2idpf _1x88idpf _z0aiyh40 _1hfk1j28 _clh3zr6s _4tpu1856",
    resizeHandleDragging: "_1hfk1856"
};
const $63e36e003ba6b889$var$isBrowser = typeof window !== 'undefined';
const $63e36e003ba6b889$var$readPersistedWidth = (storageKey)=>{
    if (!storageKey || !$63e36e003ba6b889$var$isBrowser) return null;
    try {
        const raw = window.localStorage.getItem(storageKey);
        if (raw == null) return null;
        const parsed = Number.parseFloat(raw);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
    } catch  {
        return null;
    }
};
const $63e36e003ba6b889$var$writePersistedWidth = (storageKey, width)=>{
    if (!storageKey || !$63e36e003ba6b889$var$isBrowser) return;
    try {
        window.localStorage.setItem(storageKey, String(Math.round(width)));
    } catch  {}
}; /**
    * Renders a horizontal split layout:
    *   [ chat children (flex-grow left pane) ] [ resize handle ] [ right pane (sized) ]
    *
    * - The chat (left) uses `flex: 1` so it always absorbs surplus horizontal
    *   space and is the visually dominant pane.
    * - The right pane has an explicit pixel width that the user can drag.
    *
    * The drag math is a mirror of `useResizablePanel`: `rightWidth = containerRight
    * - clientX`, clamped so the chat keeps at least `minWidth` and the right pane
    * keeps at least `adjacentMinWidth`.
    */ 
const $63e36e003ba6b889$export$581077d6f0ab5bc7 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(42);
    const { initialWidth: t1, minWidth: t2, adjacentMinWidth: t3, storageKey: storageKey, children: children } = t0;
    const initialWidth = t1 === undefined ? 380 : t1;
    const minWidth = t2 === undefined ? 480 : t2;
    const adjacentMinWidth = t3 === undefined ? 280 : t3;
    const containerRef = (0, $42omo.useRef)(null);
    let t4;
    if ($[0] !== adjacentMinWidth || $[1] !== initialWidth || $[2] !== storageKey) {
        t4 = ()=>{
            const persisted = $63e36e003ba6b889$var$readPersistedWidth(storageKey);
            const seed = persisted ?? initialWidth;
            return Math.max(seed, adjacentMinWidth);
        };
        $[0] = adjacentMinWidth;
        $[1] = initialWidth;
        $[2] = storageKey;
        $[3] = t4;
    } else t4 = $[3];
    const [rightWidth, setRightWidth] = (0, $42omo.useState)(t4);
    const [isDragging, setIsDragging] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const rightWidthRef = (0, $42omo.useRef)(rightWidth);
    let t5;
    let t6;
    if ($[4] !== rightWidth) {
        t5 = ()=>{
            rightWidthRef.current = rightWidth;
        };
        t6 = [
            rightWidth
        ];
        $[4] = rightWidth;
        $[5] = t5;
        $[6] = t6;
    } else {
        t5 = $[5];
        t6 = $[6];
    }
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (e)=>{
            e.preventDefault();
            setIsDragging(true);
        };
        $[7] = t7;
    } else t7 = $[7];
    const handleMouseDown = t7;
    let t8;
    if ($[8] !== adjacentMinWidth || $[9] !== isDragging || $[10] !== minWidth) {
        t8 = (e_0)=>{
            if (!isDragging || !containerRef.current) return;
            const rect = containerRef.current.getBoundingClientRect();
            const proposed = rect.right - e_0.clientX;
            const maxRight = Math.max(adjacentMinWidth, rect.width - minWidth);
            setRightWidth(Math.max(adjacentMinWidth, Math.min(maxRight, proposed)));
        };
        $[8] = adjacentMinWidth;
        $[9] = isDragging;
        $[10] = minWidth;
        $[11] = t8;
    } else t8 = $[11];
    const handleMouseMove = t8;
    let t9;
    if ($[12] !== storageKey) {
        t9 = ()=>{
            setIsDragging(false);
            $63e36e003ba6b889$var$writePersistedWidth(storageKey, rightWidthRef.current);
        };
        $[12] = storageKey;
        $[13] = t9;
    } else t9 = $[13];
    const handleMouseUp = t9;
    let t10;
    let t11;
    if ($[14] !== handleMouseMove || $[15] !== handleMouseUp || $[16] !== isDragging) {
        t10 = ()=>{
            if (!isDragging) return;
            const doc = (0, $hTKp4.getDocument)();
            if (!doc) return;
            const unbindMouseMove = (0, $fFa3V.bind)(doc, {
                type: "mousemove",
                listener: handleMouseMove
            });
            const unbindMouseUp = (0, $fFa3V.bind)(doc, {
                type: "mouseup",
                listener: handleMouseUp
            });
            return ()=>{
                unbindMouseMove();
                unbindMouseUp();
            };
        };
        t11 = [
            isDragging,
            handleMouseMove,
            handleMouseUp
        ];
        $[14] = handleMouseMove;
        $[15] = handleMouseUp;
        $[16] = isDragging;
        $[17] = t10;
        $[18] = t11;
    } else {
        t10 = $[17];
        t11 = $[18];
    }
    (0, $42omo.useEffect)(t10, t11);
    const t12 = `${rightWidth}px`;
    const t13 = isDragging ? "none" : undefined;
    let t14;
    if ($[19] !== t12 || $[20] !== t13) {
        t14 = {
            width: t12,
            pointerEvents: t13
        };
        $[19] = t12;
        $[20] = t13;
        $[21] = t14;
    } else t14 = $[21];
    const rightStyle = t14;
    let t15;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (0, $gMc0m.default)([
            $63e36e003ba6b889$var$styles.root
        ]);
        $[22] = t15;
    } else t15 = $[22];
    let t16;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = (0, $gMc0m.default)([
            $63e36e003ba6b889$var$styles.leftPane
        ]);
        $[23] = t16;
    } else t16 = $[23];
    let t17;
    if ($[24] !== children) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "conversation-assistant-split-layout-left",
            className: t16
        }, children);
        $[24] = children;
        $[25] = t17;
    } else t17 = $[25];
    const t18 = isDragging && $63e36e003ba6b889$var$styles.resizeHandleDragging;
    let t19;
    if ($[26] !== t18) {
        t19 = (0, $1bHXt.cx)($63e36e003ba6b889$var$styles.resizeHandle, t18);
        $[26] = t18;
        $[27] = t19;
    } else t19 = $[27];
    let t20;
    if ($[28] !== formatMessage) {
        t20 = formatMessage($63e36e003ba6b889$var$messages.resizeSidePanelAriaLabel);
        $[28] = formatMessage;
        $[29] = t20;
    } else t20 = $[29];
    let t21;
    if ($[30] !== isDragging || $[31] !== t19 || $[32] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            xcss: t19,
            "data-dragging": isDragging,
            testId: "conversation-assistant-split-layout-resize-handle",
            onMouseDown: handleMouseDown,
            "aria-label": t20
        });
        $[30] = isDragging;
        $[31] = t19;
        $[32] = t20;
        $[33] = t21;
    } else t21 = $[33];
    let t22;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = (0, $gMc0m.default)([
            $63e36e003ba6b889$var$styles.rightPanel
        ]);
        $[34] = t22;
    } else t22 = $[34];
    let t23;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eintH.SessionRightPanelSkeleton), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dZoqB.SessionRightPanelLazy), null));
        $[35] = t23;
    } else t23 = $[35];
    let t24;
    if ($[36] !== rightStyle) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "conversation-assistant-split-layout-right",
            style: rightStyle,
            className: t22
        }, t23);
        $[36] = rightStyle;
        $[37] = t24;
    } else t24 = $[37];
    let t25;
    if ($[38] !== t17 || $[39] !== t21 || $[40] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "conversation-assistant-split-layout",
            ref: containerRef,
            className: t15
        }, t17, t21, t24);
        $[38] = t17;
        $[39] = t21;
        $[40] = t24;
        $[41] = t25;
    } else t25 = $[41];
    return t25;
} : ({ initialWidth: initialWidth = 380, minWidth: minWidth = 480, adjacentMinWidth: adjacentMinWidth = 280, storageKey: storageKey, children: children })=>{
    const containerRef = (0, $42omo.useRef)(null); // Lazy initializer so we only touch `localStorage` once on mount. The
    // persisted value (if any) wins over the explicit `initialWidth` prop.
    const [rightWidth, setRightWidth] = (0, $42omo.useState)(()=>{
        const persisted = $63e36e003ba6b889$var$readPersistedWidth(storageKey);
        const seed = persisted ?? initialWidth;
        return Math.max(seed, adjacentMinWidth);
    });
    const [isDragging, setIsDragging] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)(); // Latest width is mirrored to a ref so the `mouseup` handler can persist
    // without being recreated (and re-binding listeners) on every drag tick.
    const rightWidthRef = (0, $42omo.useRef)(rightWidth);
    (0, $42omo.useEffect)(()=>{
        rightWidthRef.current = rightWidth;
    }, [
        rightWidth
    ]);
    const handleMouseDown = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        setIsDragging(true);
    }, []);
    const handleMouseMove = (0, $42omo.useCallback)((e_0)=>{
        if (!isDragging || !containerRef.current) return;
        const rect = containerRef.current.getBoundingClientRect();
        const proposed = rect.right - e_0.clientX;
        const maxRight = Math.max(adjacentMinWidth, rect.width - minWidth);
        setRightWidth(Math.max(adjacentMinWidth, Math.min(maxRight, proposed)));
    }, [
        isDragging,
        minWidth,
        adjacentMinWidth
    ]);
    const handleMouseUp = (0, $42omo.useCallback)(()=>{
        setIsDragging(false); // Persist the resting width once per drag (not on every mousemove tick).
        $63e36e003ba6b889$var$writePersistedWidth(storageKey, rightWidthRef.current);
    }, [
        storageKey
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isDragging) return;
        const doc = (0, $hTKp4.getDocument)();
        if (!doc) return;
        const unbindMouseMove = (0, $fFa3V.bind)(doc, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        const unbindMouseUp = (0, $fFa3V.bind)(doc, {
            type: 'mouseup',
            listener: handleMouseUp
        });
        return ()=>{
            unbindMouseMove();
            unbindMouseUp();
        };
    }, [
        isDragging,
        handleMouseMove,
        handleMouseUp
    ]);
    const rightStyle = {
        width: `${rightWidth}px`,
        pointerEvents: isDragging ? 'none' : undefined
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "conversation-assistant-split-layout",
        ref: containerRef,
        className: (0, $gMc0m.default)([
            $63e36e003ba6b889$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "conversation-assistant-split-layout-left",
        className: (0, $gMc0m.default)([
            $63e36e003ba6b889$var$styles.leftPane
        ])
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: (0, $1bHXt.cx)($63e36e003ba6b889$var$styles.resizeHandle, isDragging && $63e36e003ba6b889$var$styles.resizeHandleDragging),
        "data-dragging": isDragging,
        testId: "conversation-assistant-split-layout-resize-handle",
        onMouseDown: handleMouseDown,
        "aria-label": formatMessage($63e36e003ba6b889$var$messages.resizeSidePanelAriaLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "conversation-assistant-split-layout-right",
        style: rightStyle,
        className: (0, $gMc0m.default)([
            $63e36e003ba6b889$var$styles.rightPanel
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eintH.SessionRightPanelSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dZoqB.SessionRightPanelLazy), null))));
};
module.exports["SplitLayout"] = $63e36e003ba6b889$export$581077d6f0ab5bc7;

});

parcelRegister("dZoqB", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $5c33135279b96d22$export$a0bce28b49dab85d = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8nHGO")).then((module)=>({
            default: module.SessionRightPanel
        })));
module.exports["SessionRightPanelLazy"] = $5c33135279b96d22$export$a0bce28b49dab85d;

});

parcelRegister("8nHGO", function(module, exports) {

let $61a25c8d3b11db1a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $61a25c8d3b11db1a$var$load("6wr18"),
    $61a25c8d3b11db1a$var$load("iUEjf"),
    $61a25c8d3b11db1a$var$load("ffEVr"),
    $61a25c8d3b11db1a$var$load("gILUb")
]).then(()=>parcelRequire('bYzTn'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("eintH", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $cO1el = parcelRequire("cO1el");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");


var $kpYGL = parcelRequire("kpYGL");


var $k10Hk = parcelRequire("k10Hk");

const $526a73cf567c91d0$var$styles = {
    root: "_4t3i1osq _1bsb1osq _vchhusvi _18m91wug",
    content: "_zulpv47k _2rkopb1k _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _2lx21bp4 _19pkv47k _otyrv47k _18u0v47k _2hwxv47k _ca0qv47k _u5f3utpp _n3tdv47k _19bvutpp",
    section: "_zulputpp _1e0c1txw _2lx21bp4",
    pillsContainer: "_zulp1b66 _1e0c1txw _1n261g80",
    pill: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c116y _4cvr1h6o _ca0q1b66 _n3td1b66 _19bvu2gc _u5f3u2gc _bfhksm61",
    artefactRow: "_2rkopb1k _zulputpp _189ee4h9 _1dqonqa1 _1h6d1l7x _bozgutpp _y4tiutpp _1tkevbgk _1e0c1txw _4cvr1h6o"
};
const $526a73cf567c91d0$var$PILL_CONTENT_WIDTHS = [
    120,
    88,
    162,
    65,
    128
];
const $526a73cf567c91d0$export$659bc7cd6c22a575 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(18);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $k10Hk.default).attachmentsHeading);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "xsmall"
        }, t0);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $526a73cf567c91d0$var$styles.pillsContainer
        }, $526a73cf567c91d0$var$PILL_CONTENT_WIDTHS.map($526a73cf567c91d0$var$_temp));
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $526a73cf567c91d0$var$styles.section
        }, t1, t2);
        $[5] = t1;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== formatMessage) {
        t4 = formatMessage((0, $k10Hk.default).outputHeading);
        $[7] = formatMessage;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "xsmall"
        }, t4);
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = [
            150,
            120,
            160
        ];
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.050"
        }, t6.map($526a73cf567c91d0$var$_temp2));
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== t5) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $526a73cf567c91d0$var$styles.section
        }, t5, t7);
        $[13] = t5;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== t3 || $[16] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $526a73cf567c91d0$var$styles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $526a73cf567c91d0$var$styles.content
        }, t3, t8));
        $[15] = t3;
        $[16] = t8;
        $[17] = t9;
    } else t9 = $[17];
    return t9;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $526a73cf567c91d0$var$styles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $526a73cf567c91d0$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $526a73cf567c91d0$var$styles.section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, formatMessage((0, $k10Hk.default).attachmentsHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $526a73cf567c91d0$var$styles.pillsContainer
    }, $526a73cf567c91d0$var$PILL_CONTENT_WIDTHS.map((width)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            key: width,
            xcss: $526a73cf567c91d0$var$styles.pill
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: width,
            height: 14,
            isShimmering: true
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $526a73cf567c91d0$var$styles.section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, formatMessage((0, $k10Hk.default).outputHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.050"
    }, [
        150,
        120,
        160
    ].map((titleWidth)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            key: titleWidth,
            xcss: $526a73cf567c91d0$var$styles.artefactRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: 32,
            height: 32,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: titleWidth,
            height: 14,
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: 100,
            height: 12,
            isShimmering: true
        }))))))));
};
function $526a73cf567c91d0$var$_temp(width) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        key: width,
        xcss: $526a73cf567c91d0$var$styles.pill
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: width,
        height: 14,
        isShimmering: true
    }));
}
function $526a73cf567c91d0$var$_temp2(titleWidth) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        key: titleWidth,
        xcss: $526a73cf567c91d0$var$styles.artefactRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: 32,
        height: 32,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: titleWidth,
        height: 14,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: 100,
        height: 12,
        isShimmering: true
    })));
}
module.exports["SessionRightPanelSkeleton"] = $526a73cf567c91d0$export$659bc7cd6c22a575;

});

parcelRegister("k10Hk", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $a4cf825d3b24767d$var$messages = (0, $aXWIB.defineMessages)({
    attachmentsHeading: {
        id: "ai-mate.conversation-assistant.split-layout.default-right-panel.attachments-heading-non-final",
        defaultMessage: "Attachments"
    },
    outputHeading: {
        id: "ai-mate.conversation-assistant.split-layout.default-right-panel.output-heading-non-final",
        defaultMessage: "Output"
    }
});
var $a4cf825d3b24767d$export$2e2bcd8739ae039 = $a4cf825d3b24767d$var$messages;
module.exports["default"] = $a4cf825d3b24767d$export$2e2bcd8739ae039;

});

parcelRegister("b6KjD", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $caX7N = parcelRequire("caX7N");


var $2O3ot = parcelRequire("2O3ot");


var $8zSyE = parcelRequire("8zSyE");


var $hR4U4 = parcelRequire("hR4U4");


var $ajVP3 = parcelRequire("ajVP3");

const $bd68956a97b4db5f$var$styles = {
    wrapper: "_vchhusvi _1bsb1ina _19pkpxbi _4t3inau3 _bfhkvuon _1e0c1txw _2lx21bp4 _ae4v1fhb _4cvr1fhb",
    wrapperNav4: "_vchhusvi _1bsb1osq _4t3i1osq _bfhkvuon _1e0c1txw _2lx21bp4 _ae4v1fhb _4cvr1fhb",
    wrapperHeight: "_1tke1edt",
    externalEmbed: "_19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _1bsb1osq _4t3i1osq",
    fullscreenDebug: "_1r04ze3t _kqsw1n9t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _4t3in7od _1bsbn7od",
    withExternalStagingArea: "_1bsb1osq"
};
const $bd68956a97b4db5f$var$stylesBorder = {
    borderNavV3: "_1h6d1l7x _189ee4h9 _1dqonqa1 _13li1mok _qrwq1mok",
    borderNavV4: "",
    borderFullScreenDebug: "_2rko1mok _1dqonqa1 _1h6d1w55 _189e1mok",
    borderExternalEmbed: "",
    borderStagingArea: "_2rkopb1k _16qst7xp"
};
const $bd68956a97b4db5f$var$miniModalWrapperStyles = null; // When rendered inside a full-screen MaximisedModal, the modal already provides
// width/height/border-radius/shadow. The wrapper should fill the modal body
// without the sidebar-mode top margin or border-radius.
const $bd68956a97b4db5f$var$fullScreenModalWrapperStyles = null;
const $bd68956a97b4db5f$export$6661021c36f0a701 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(26);
    const { testId: testId, children: children, isNav4Enabled: isNav4Enabled, mode: mode } = t0;
    const isMiniModal = mode === (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL;
    const isFullScreenModal = mode === (0, $hR4U4.ConversationAssistantUIModes).FULL_SCREEN_MODAL && (0, $dh538.fg)("agent_session_experience_fg");
    const { externalEmbed: externalEmbed, fullScreen: fullScreen, elements: elements, isSplitLayout: isSplitLayout, splitLayoutInitialWidth: splitLayoutInitialWidth, splitLayoutMinWidth: splitLayoutMinWidth, splitLayoutAdjacentMinWidth: splitLayoutAdjacentMinWidth, splitLayoutStorageKey: splitLayoutStorageKey } = (0, $8zSyE.useUIConfig)();
    const { stagingAreaMode: stagingAreaMode } = (0, $2O3ot.useStagingAreaState)();
    let t1;
    if ($[0] !== fullScreen || $[1] !== isSplitLayout) {
        t1 = !!fullScreen && !!isSplitLayout && (0, $dh538.fg)("agent_session_experience_fg");
        $[0] = fullScreen;
        $[1] = isSplitLayout;
        $[2] = t1;
    } else t1 = $[2];
    const isSplitLayoutActive = t1;
    let t2;
    if ($[3] !== children || $[4] !== isSplitLayoutActive || $[5] !== splitLayoutAdjacentMinWidth || $[6] !== splitLayoutInitialWidth || $[7] !== splitLayoutMinWidth || $[8] !== splitLayoutStorageKey) {
        t2 = ()=>isSplitLayoutActive ? /*#__PURE__*/ $42omo.createElement((0, $ajVP3.SplitLayout), {
                initialWidth: splitLayoutInitialWidth,
                minWidth: splitLayoutMinWidth,
                adjacentMinWidth: splitLayoutAdjacentMinWidth,
                storageKey: splitLayoutStorageKey
            }, children) : children;
        $[3] = children;
        $[4] = isSplitLayoutActive;
        $[5] = splitLayoutAdjacentMinWidth;
        $[6] = splitLayoutInitialWidth;
        $[7] = splitLayoutMinWidth;
        $[8] = splitLayoutStorageKey;
        $[9] = t2;
    } else t2 = $[9];
    const renderInnerChildren = t2;
    const shouldShowStagingArea = stagingAreaMode === "inline";
    const fullscreenDebugEnabled = localStorage.getItem("DEBUG_rovo_chat_fullscreen") === "true" && (0, $dh538.fg)("rovo_chat_show_local_frontend_components");
    const shouldUseWrapperNav4Styles = isNav4Enabled;
    if (fullscreenDebugEnabled) {
        const t3 = shouldUseWrapperNav4Styles ? $bd68956a97b4db5f$var$styles.wrapperNav4 : $bd68956a97b4db5f$var$styles.wrapper;
        const t4 = isMiniModal ? "_2rko1tm3 _1reo15vq _18m915vq _16qs130s _4t3i1wug _k8m0wor5 _1oec15uc _6fl4indk" : $bd68956a97b4db5f$var$styles.wrapperHeight;
        const t5 = externalEmbed && $bd68956a97b4db5f$var$styles.externalEmbed;
        let t6;
        if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
            t6 = (0, $gMc0m.default)([
                t3,
                t4,
                t5,
                $bd68956a97b4db5f$var$styles.fullscreenDebug,
                $bd68956a97b4db5f$var$stylesBorder.borderFullScreenDebug
            ]);
            $[10] = t3;
            $[11] = t4;
            $[12] = t5;
            $[13] = t6;
        } else t6 = $[13];
        let t7;
        if ($[14] !== renderInnerChildren) {
            t7 = renderInnerChildren();
            $[14] = renderInnerChildren;
            $[15] = t7;
        } else t7 = $[15];
        let t8;
        if ($[16] !== t6 || $[17] !== t7 || $[18] !== testId) {
            t8 = /*#__PURE__*/ $42omo.createElement((0, $caX7N.default), {
                zIndex: 500
            }, /*#__PURE__*/ $42omo.createElement("div", {
                "data-testid": testId,
                "data-rovo-chat-panel": "true",
                className: t6
            }, t7));
            $[16] = t6;
            $[17] = t7;
            $[18] = testId;
            $[19] = t8;
        } else t8 = $[19];
        return t8;
    }
    const getBorderStyle = ()=>{
        if (elements?.stagingAreaEnabled) return "borderStagingArea";
        if (externalEmbed) return "borderExternalEmbed";
        if (fullscreenDebugEnabled) return "borderFullScreenDebug";
        if (shouldUseWrapperNav4Styles) return "borderNavV4";
        return "borderNavV3";
    };
    const t3 = "true";
    const t4 = (0, $gMc0m.default)([
        shouldUseWrapperNav4Styles ? $bd68956a97b4db5f$var$styles.wrapperNav4 : $bd68956a97b4db5f$var$styles.wrapper,
        isMiniModal ? "_2rko1tm3 _1reo15vq _18m915vq _16qs130s _4t3i1wug _k8m0wor5 _1oec15uc _6fl4indk" : $bd68956a97b4db5f$var$styles.wrapperHeight,
        externalEmbed && $bd68956a97b4db5f$var$styles.externalEmbed,
        $bd68956a97b4db5f$var$stylesBorder[getBorderStyle()],
        fullScreen && shouldShowStagingArea && $bd68956a97b4db5f$var$styles.withExternalStagingArea,
        isFullScreenModal && "_2rko12b0 _189ee4h9 _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _1bsb1osq _4t3i1osq"
    ]);
    let t5;
    if ($[20] !== renderInnerChildren) {
        t5 = renderInnerChildren();
        $[20] = renderInnerChildren;
        $[21] = t5;
    } else t5 = $[21];
    let t6;
    if ($[22] !== t4 || $[23] !== t5 || $[24] !== testId) {
        t6 = /*#__PURE__*/ $42omo.createElement("div", {
            "data-testid": testId,
            "data-rovo-chat-panel": t3,
            className: t4
        }, t5);
        $[22] = t4;
        $[23] = t5;
        $[24] = testId;
        $[25] = t6;
    } else t6 = $[25];
    return t6;
} : ({ testId: testId, children: children, isNav4Enabled: isNav4Enabled, mode: mode })=>{
    const isMiniModal = mode === (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL;
    const isFullScreenModal = mode === (0, $hR4U4.ConversationAssistantUIModes).FULL_SCREEN_MODAL && (0, $dh538.fg)('agent_session_experience_fg');
    const { externalEmbed: externalEmbed, fullScreen: fullScreen, elements: elements, isSplitLayout: isSplitLayout, splitLayoutInitialWidth: splitLayoutInitialWidth, splitLayoutMinWidth: splitLayoutMinWidth, splitLayoutAdjacentMinWidth: splitLayoutAdjacentMinWidth, splitLayoutStorageKey: splitLayoutStorageKey } = (0, $8zSyE.useUIConfig)();
    const { stagingAreaMode: stagingAreaMode } = (0, $2O3ot.useStagingAreaState)();
    const isSplitLayoutActive = !!fullScreen && !!isSplitLayout && (0, $dh538.fg)('agent_session_experience_fg');
    const renderInnerChildren = ()=>isSplitLayoutActive ? /*#__PURE__*/ $42omo.createElement((0, $ajVP3.SplitLayout), {
            initialWidth: splitLayoutInitialWidth,
            minWidth: splitLayoutMinWidth,
            adjacentMinWidth: splitLayoutAdjacentMinWidth,
            storageKey: splitLayoutStorageKey
        }, children) : children;
    const shouldShowStagingArea = stagingAreaMode === 'inline'; // Purely for FE team testing fullscreen where branch deploys are accessible
    // The use of localStorage and a private FF should make this safe, and it's our
    // best bet to improve dev velocity at the moment. Once Atlas has local consumption
    // we can remove this
    const fullscreenDebugEnabled = localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' && (0, $dh538.fg)('rovo_chat_show_local_frontend_components');
    const shouldUseWrapperNav4Styles = isNav4Enabled;
    if (fullscreenDebugEnabled) return /*#__PURE__*/ $42omo.createElement((0, $caX7N.default), {
        zIndex: 500
    }, /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId,
        "data-rovo-chat-panel": "true",
        className: (0, $gMc0m.default)([
            shouldUseWrapperNav4Styles ? $bd68956a97b4db5f$var$styles.wrapperNav4 : $bd68956a97b4db5f$var$styles.wrapper,
            isMiniModal ? "_2rko1tm3 _1reo15vq _18m915vq _16qs130s _4t3i1wug _k8m0wor5 _1oec15uc _6fl4indk" : $bd68956a97b4db5f$var$styles.wrapperHeight,
            externalEmbed && $bd68956a97b4db5f$var$styles.externalEmbed,
            $bd68956a97b4db5f$var$styles.fullscreenDebug,
            $bd68956a97b4db5f$var$stylesBorder.borderFullScreenDebug
        ])
    }, renderInnerChildren()));
    const getBorderStyle = ()=>{
        if (elements?.stagingAreaEnabled) return 'borderStagingArea';
        if (externalEmbed) return 'borderExternalEmbed';
        if (fullscreenDebugEnabled) // this is not possible because if condition above, but adding it here for completeness
        return 'borderFullScreenDebug';
        if (shouldUseWrapperNav4Styles) return 'borderNavV4';
        return 'borderNavV3';
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId,
        "data-rovo-chat-panel": "true",
        className: (0, $gMc0m.default)([
            shouldUseWrapperNav4Styles ? $bd68956a97b4db5f$var$styles.wrapperNav4 : $bd68956a97b4db5f$var$styles.wrapper,
            isMiniModal ? "_2rko1tm3 _1reo15vq _18m915vq _16qs130s _4t3i1wug _k8m0wor5 _1oec15uc _6fl4indk" : $bd68956a97b4db5f$var$styles.wrapperHeight,
            externalEmbed && $bd68956a97b4db5f$var$styles.externalEmbed,
            $bd68956a97b4db5f$var$stylesBorder[getBorderStyle()],
            fullScreen && shouldShowStagingArea && $bd68956a97b4db5f$var$styles.withExternalStagingArea,
            isFullScreenModal && "_2rko12b0 _189ee4h9 _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _1bsb1osq _4t3i1osq"
        ])
    }, renderInnerChildren());
};
module.exports["MainWrapper"] = $bd68956a97b4db5f$export$6661021c36f0a701;

});


//# sourceMappingURL=ObjectSidebarControl.3511b278.js.map
